import { Injectable } from '@angular/core';
import { HttpService } from "../core/http/http.service";
import { IIdNameDescription } from '../_entities';
import { IContractDemarcationListAnswer, IDemarcationListTemplate } from '../_entities/demarcation';
import { DataAccessServiceBase } from "./dataaccess.base.service";
import { ModelStateValidationService } from "./model-state-validation.service";

@Injectable()
export class DemarcationListService extends DataAccessServiceBase<IDemarcationListTemplate> {

    constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
        super(httpService, validationService);
    }

    getControllerUrl(): string {
        return "api/demarcation";
    }

    getTemplates(): Promise<IIdNameDescription[] | any> {
		return this.httpService.get<any[]>("api/demarcation/templates")
            .catch(e => {
                this.validationService.handleError(e);
            });
    }

 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/demarcation-list.service.ts